import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Button, Container, Form, FormGroup, Input, Label } from 'reactstrap';

export default class StudentEdit extends Component {

    emptyItem = {
        firstName: '',
        lastName: '',
        email: ''
    };

    constructor(props) {
        super(props);
        this.state = {
            item: this.emptyItem
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async componentDidMount() {
        if (this.props.match.params.id !== 'new') {
            const student = await (await fetch(`/api/v1/students/${this.props.match.params.id}`)).json();

            this.setState({ item: student });
        }
    }

    handleChange(event) {
        const target = event.target;
        const value = target.value;
        const name = target.name;
        let item = { ...this.state.item };
        item[name] = value;
        this.setState({ item });
    }

    async handleSubmit(event) {
        event.preventDefault();
        const { item } = this.state;

        await fetch('/api/v1/students' + (item.id ? '/' + item.id : ''), {
            method: (item.id) ? 'PUT' : 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(item),
        });
        this.props.history.push('/students');
    }

    render() {
        const { item } = this.state;
        const title = <h2>{item.id ? 'Edit Student' : 'Add Student'}</h2>;

        return <div>
            <Container> 
                {title}
                <Form onSubmit={this.handleSubmit}>
                    <FormGroup>
                        <Label for="name">Nom</Label>
                        <Input type="text" name="lastName" id="lastName" value={item.lastName || ''}
                            onChange={this.handleChange} autoComplete="lastName" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="name">Prénom</Label>
                        <Input type="text" name="firstName" id="firstName" value={item.firstName || ''}
                            onChange={this.handleChange} autoComplete="firstName" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="email">Email</Label>
                        <Input type="text" name="email" id="email" value={item.email || ''}
                            onChange={this.handleChange} autoComplete="email" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="email">Téléphone</Label>
                        <Input type="text" name="phone" id="phone" value={item.phone || ''}
                            onChange={this.handleChange} autoComplete="phone" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="name">Adresse</Label>
                        <Input type="text" name="address" id="address" value={item.address || ''}
                            onChange={this.handleChange} autoComplete="address" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="name">Code Postal</Label>
                        <Input type="text" name="zipCode" id="zipCode" value={item.zipCode || ''}
                            onChange={this.handleChange} autoComplete="zipCode" />
                    </FormGroup>
                    <FormGroup>
                        <Label for="name">Ville</Label>
                        <Input type="text" name="city" id="city" value={item.city || ''}
                            onChange={this.handleChange} autoComplete="city" />
                    </FormGroup>
                    <br/>
                    <FormGroup>
                        <Button color="primary" type="submit">Save</Button>{' '}
                        <Button color="secondary" tag={Link} to="/students">Cancel</Button>
                    </FormGroup>

                    
                    
                </Form>
            </Container>
        </div>
    }


}
//export default withRouter(StudentEdit);